import { MenuItem } from 'primeng/api';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MessagesService } from '@core/_services/messages.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiV6Service } from '@service/apiv6.service';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-add-supervbase',
    templateUrl: './add-supervbase.component.html',
    styleUrls: ['./add-supervbase.component.scss'],
})
export class AddSupervBaseComponent implements OnInit {
    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    public items: Array<MenuItem>;

    @Input()
    public groupList = [];

    @Input()
    public userList = [];

    @Input()
    public basketList = [];


    constructor(
        private translate: TranslateService,
        private api: ApiV6Service,
        protected _messageService: MessagesService) {
        }

    ngOnInit() {
    }

    public async validate(result) {
        let wRes: any = {};
        // id de la requête forcé à 0 : création
        result.id = 0;
        result.data.id = 0;
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('updatesupervbase', result ));
            this.onValidate.emit({ data: wRes.data, duplicate: false });            
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
    }

    cancel() {
        this.onCancel.emit({ id: null });
    }
}
